export default [
  {
    path: '/popup/:name/:id?',
    name: 'detailPopup',
    component: () => import('@/pages/DetailPopup.vue'),
    meta: {
      rule: 'editor',
    },
  },
  {
    path: '/drilldown-report/:command?/:cacheKey?',
    name: 'drilldownReport',
    component: () => import(/*webpackChunkName:'detail'*/ '@/pages/DrillDownReportPage.vue'),
    meta: {
      rule: 'editor',
    },
  },
  {
    path: '/500',
    name: '500',
    component: () => import('@/pages/500.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/403',
    name: '403',
    component: () => import('@/pages/403.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/login-callback',
    name: 'LoginCallback',
    component: () => import('@/pages/LoginCallback.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/misa-id-security',
    name: 'MisaIdSecurity',
    component: () => import('@/pages/MisaIdSecurity.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/Login.vue'),
    meta: {
      anonymous: true,
    },
  },

  {
    path: '/logout',
    name: 'Logout',
    component: () => import(/* webpackChunkName:'logout'*/ '@/pages/Logout.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/confirmRedirect',
    name: 'confirm-redirect',
    component: () => import(/* webpackChunkName:'demo'*/ '@/pages/ConfirmRedirect.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/firstLogin',
    name: 'first-login',
    component: () => import(/* webpackChunkName:'demo'*/ '@/pages/CreateDbFirstLogin.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/converting',
    name: 'converting',
    component: () => import(/* webpackChunkName:'demo'*/ '@/pages/DBConverting.vue'),
    meta: {
      anonymous: true,
    },
  },
    {
    path: '/nps',
    name: 'nps',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/common/NPSForm.vue'),
    meta: {
      anonymous: true,
    },
  },
];
